import React from "react";

function ProductCardHeaders({ headers,active,setActive }) {


  const handleHeader = {
    items:headers.items,
    categories:headers.categories,
  }

  return (
    <div>
      <div className="border-gray-800 h-[50px] mt-3 flex flex-wrap gap-4 text-[18px]">
        {Object.entries(handleHeader).map(([key, value],index) => (
          <div key={key} className="cursor-pointer font-roboto  ">
            {key === "categories" || key === "items" || key ==="currentItemCount" || key === "totalCategories"  ? (
              <div className="flex">
                <div className="mt-2" onClick={()=>setActive(index)} >
                  {key === "categories" ? "Categories" : key === "items" ? "Product" : ""}
                </div>
                <div className="text-[13px] text-[#6f6f6f] ml-1">
                  {
                    key === "items"?headers.currentItemCount:key ==="categories"?headers.totalCategories:""
                  }
                </div>
              </div>
            ) : ""}
            <div className={`${active===index?"border-b-2 border-gray-500":"border-b-2 border-gray-200"}`}></div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProductCardHeaders;
